<template>
    <DFormRow
        :label="__('products.productPrices.form.setup_fee')"
        :is-required="true"
        :error="errors.setup_fee"
    >
        <DInput
            id="setup_fee"
            :model-value="modelValue"
            maxlength="13"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'SetupFee',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['update:modelValue']
}
</script>
